import React from 'react';
import '../styles/categoryIndicator.scss';

const CategoryIndicator = ({ origin }) => {
  return (
    <div className="categoryIndicator">
      <div className="categoryIndicator__bar" />
      <h3 className="bold">{origin}</h3>
    </div>
  );
};

export default CategoryIndicator;
